module.exports = __webpack_public_path__ + "img/caretArrowDown_b.c3cc5c2c.svg";